import React, { createContext, ReactNode, useContext } from "react";
import {
  calculateHeader,
  HorizontalHeaders,
  VerticalSeasons,
} from "../pages/components/FuturesTable/utils/header.utils";
import { DueDateContext } from "./DueDateContext";

export const ShipmentHeaderContext = createContext<{
  horizontalHeaders: HorizontalHeaders;
  verticalSeasons: VerticalSeasons;
  verticalMonths: string[];
  monthsInFirstTwoSeasons: number;
}>({
  horizontalHeaders: {} as HorizontalHeaders,
  verticalSeasons: [],
  verticalMonths: [],
  monthsInFirstTwoSeasons: 0,
});

export const ShipmentHeaderProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { shipmentMonthDate } = useContext(DueDateContext);
  const {
    horizontalHeaders,
    verticalSeasons,
    verticalMonths,
    monthsInFirstTwoSeasons,
  } = calculateHeader(shipmentMonthDate);
  return (
    <ShipmentHeaderContext.Provider
      value={{
        horizontalHeaders,
        verticalSeasons,
        verticalMonths,
        monthsInFirstTwoSeasons,
      }}
    >
      {children}
    </ShipmentHeaderContext.Provider>
  );
};
